import api from "./api.js";

export default class LevelApi {
  static async getList(data) {
    return await api.get(`api/level`, data);
  }

  static async edit(id, data) {
    return await api.patch(`api/level/${id}`, data);
  }
}
